import Grid from '@material-ui/core/Grid';
import React, { useState } from 'react';
import { DonutChart } from '../../../charts/DonutChart';
import { MyChartDataTable } from '../../../charts/MyChartDataTable';
import { SwitchBlueGreen } from '../../../components/Switch';
import { Venda } from '../../../models/venda';
import { DashPanel } from '../DashPanel';

export interface PanelMixCombustiveisProps {
  vendaCombustiveis: Venda[];
  totalLitragem: number;
  totalLiquido: number;
  colorArray: string[];
}

export const PanelMixCombustiveis = (props: PanelMixCombustiveisProps) => {
  const [checkedPorQtd, setCheckedPorQtd] = useState(true);

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckedPorQtd(event.target.checked);
  }

  var dados = undefined;

  if (checkedPorQtd === true)
    dados = props.vendaCombustiveis.map(x => ({ sigla: x.sigla!, name: x.nome, value: Math.round(((x.quantidade / props.totalLitragem) * 100) * 10) / 10 }));
  else
    dados = props.vendaCombustiveis.map(x => ({ sigla: x.sigla!, name: x.nome, value: Math.round(((x.totalLiquido / props.totalLiquido) * 100) * 10) / 10 }));


  return <DashPanel
    title="Mix"
    headerAction={
      <div>
        <Grid component="label" container alignItems="center" spacing={1}>
          <Grid item>R$</Grid>
          <Grid item>
            <SwitchBlueGreen checked={checkedPorQtd} onChange={handleSwitchChange} name="switchMixCombustiveis" />
          </Grid>
          <Grid item>(L)</Grid>
        </Grid>
      </div>
    }
  >
    <div style={{ paddingBottom: '8px' }}>
      <DonutChart
        dados={dados}
        showLegend={false}
        colorArray={props.colorArray}
      />
    </div>
    <MyChartDataTable rows={dados} format="0.0" sufix="%" />
  </DashPanel>;
}
